const languages = [
  "GO",
  "PYTHON",
  "JAVASCRIPT",
  "JAVA",
  "SQL",
  "HTML + CSS",
];

export default languages;
